import React from 'react';
import Navigation from './tulote/Navigation';
import HeroSection from './tulote/HeroSection';
import DualCTASection from './tulote/DualCTASection';
import RealtorSection from './tulote/RealtorSection';
import HowItWorks from './tulote/HowItWorks';
import AboutSection from './tulote/AboutSection';
import SubscriptionSection from './tulote/SubscriptionSection';
import ContactSection from './tulote/ContactSection';
import ProjectViewerSection from './tulote/ProjectViewerSection';
import CallToAction from './tulote/CallToAction';
import Footer from './tulote/Footer';
import ThemeTogglerTwo from './tulote/ThemeTogglerTwo';
import CadAssistantFloat from './tulote/CadAssistantFloat';
import MobileAppSection from './tulote/MobileAppSection';
import { ThemeProvider } from './ThemeProvider';

function LandingPage() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-white dark:bg-gray-950 transition-colors">
        {/* Navigation */}
        <Navigation />

        {/* Hero Section */}
        <section id="hero">
          <HeroSection />
        </section>

        {/* Mobile App Section */}
        <section id="app-movil">
          <MobileAppSection />
        </section>

        {/* Dual CTA Section */}
        <DualCTASection />

        {/* Realtor Section */}
        <RealtorSection />

        {/* How It Works */}
        <section id="how-it-works">
          <HowItWorks />
        </section>

        {/* About Section */}
        <section id="about">
          <AboutSection />
        </section>

        {/* Subscription Plans Section */}
        <section id="planes">
          <SubscriptionSection />
        </section>

        {/* Contact Section */}
        <section id="contact">
          <ContactSection />
        </section>

        {/* Project Viewer Section */}
        <section id="visor">
          <ProjectViewerSection />
        </section>

        {/* Call to Action */}
        <CallToAction />

        {/* Footer */}
        <Footer />

        {/* CAD Assistant Float */}
        <CadAssistantFloat />

        {/* Theme Toggle Button */}
        <div className="fixed bottom-6 right-6 z-50 hidden sm:block">
          <ThemeTogglerTwo />
        </div>
      </div>
    </ThemeProvider>
  );
}

export default LandingPage;

